import { AppState } from './app';
import * as constants from '../constants';

// We type the payload cast inside each switch case:
export type LoadingErrorNoticeActionType = {
  type:
    | typeof constants.LOADING
    | typeof constants.POST_ERROR
    | typeof constants.FETCH_ERROR
    | typeof constants.NOTICE_RECEIVED
    | typeof constants.CLEARED_ERROR
    | typeof constants.CLEARED_NOTICE;

  payload: any;
};

export const loadingErrorNoticeReducer = (state: AppState, action: LoadingErrorNoticeActionType) => {
  switch (action.type) {
    case constants.LOADING: {
      let loadingObj = {};
      if (action.payload.name) {
        loadingObj[action.payload.name] = action.payload.value;
      } else {
        loadingObj['general'] = action.payload;
      }
      return {
        ...state,
        loading: {
          ...state.loading,
          ...loadingObj,
        },
      };
    }
    case constants.POST_ERROR: {
      const codeName = action.payload.code + '_' + action.payload.class;
      return {
        ...state,
        errors: {
          ...state.errors,
          [codeName]: {
            message: action.payload.details,
            status: action.payload.status,
            code: action.payload.code,
            class: action.payload.class,
          },
        },
        loading: {
          general: false,
        },
      };
    }
    case constants.FETCH_ERROR: {
      const codeName = action.payload.code + '_' + action.payload.class;
      return {
        ...state,
        errors: {
          ...state.errors,
          [codeName]: {
            message: action.payload.details,
            status: action.payload.status,
            code: action.payload.code,
            class: action.payload.class,
          },
        },
        loading: {
          general: false,
        },
      };
    }
    case constants.NOTICE_RECEIVED: {
      const codeName = action.payload.code + '_' + action.payload.urn;
      return {
        ...state,
        notices: {
          ...state.notices,
          [codeName]: {
            city: action.payload.city,
            code: action.payload.code,
            id: action.payload.id,
            message: action.payload.message,
            name: action.payload.name,
            urn: action.payload.urn,
            status: action.payload.status,
          },
        },
      };
    }

    case constants.CLEARED_ERROR: {
      let newErrors = { ...state.errors };
      if (action.payload) {
        const codeName = action.payload.code + '_' + action.payload.class;
        newErrors[codeName] && delete newErrors[codeName];
      } else {
        newErrors = {};
      }
      return {
        ...state,
        errors: { ...newErrors },
      };
    }

    case constants.CLEARED_NOTICE: {
      let newNotices = { ...state.notices };
      if (action.payload) {
        const codeName = action.payload.code + '_' + action.payload.urn;
        newNotices[codeName] && delete newNotices[codeName];
      } else {
        newNotices = {};
      }

      return {
        ...state,
        notices: { ...newNotices },
      };
    }
  }
};
